import React from 'react';
import { ShieldCheck, Star, Download, Infinity, ShieldAlert } from 'lucide-react';
export function HeroSectionV2() {
  const handleCTAClick = () => {
    // Fire Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    // Redirect to base Shopify checkout
    window.location.href = 'https://www.tubienestarinterno.com/cart/53346355937617:1';
  };
  return <section className="pt-8 pb-10 px-4 bg-white" data-id="element-163">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-164">
        <div className="order-2 md:order-1 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-165">
          <div className="inline-flex items-center space-x-1 bg-brand-gold-light text-yellow-800 px-4 py-1.5 rounded-full text-xs font-bold mb-6 tracking-wide uppercase border border-yellow-200" data-id="element-166">
            <ShieldCheck className="w-4 h-4 mr-1" data-id="element-167" />
            Ciencia Aplicada a la Conducta Canina
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight mb-4 text-gray-900" data-id="element-168">
            CIENCIA APLICADA A LA CONDUCTA CANINA: ¿Su perro se bloquea, ignora
            sus llamados o entra en pánico al pisar la calle?
          </h1>

          <p className="text-gray-600 mb-8 text-base sm:text-lg leading-relaxed" data-id="element-169">
            Active el INTERRUPTOR NEUROLÓGICO de calma en 7 días. Silencie el
            exceso de cortisol y recupere el control sin tirones y sin gritos.
          </p>

          {/* Price Display */}
          <div className="mb-6 flex flex-col items-center md:items-start" data-id="element-170">
            <div className="text-gray-400 line-through text-2xl font-bold mb-1" data-id="element-171">
              $27.00
            </div>
            <div className="text-[48px] font-bold text-[#DC2626] leading-none mb-2" data-id="element-172">
              $9.95 USD
            </div>
            <div className="text-sm font-bold text-gray-800 bg-gray-100 px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-173">
              -63% OFF SOLO POR HOY
            </div>
          </div>

          <button onClick={handleCTAClick} className="w-full md:w-auto bg-brand-teal hover:bg-brand-teal-dark text-white font-bold py-4 px-8 rounded-[20px] shadow-xl transition-all transform hover:scale-105 text-lg" data-id="element-174">
            SÍ, QUIERO PASEOS EN PAZ
          </button>

          <div className="mt-3 flex items-center justify-center md:justify-start gap-1 text-sm text-gray-700 font-medium flex-wrap" data-id="element-175">
            <span className="flex items-center gap-0.5" data-id="element-176">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-177" />)}
            </span>
            <span className="ml-1" data-id="element-178">
              +8,500 dueños en México ya comenzaron su Protocolo
            </span>
          </div>

          {/* Trust Row */}
          <div className="mt-5 flex flex-row flex-wrap items-center justify-center md:justify-start gap-4 sm:gap-6 text-sm text-gray-600 font-medium" data-id="element-179">
            <span className="flex items-center" data-id="element-180">
              <Download className="w-4 h-4 mr-1.5 text-brand-teal" data-id="element-181" /> Acceso
              Inmediato
            </span>
            <span className="flex items-center" data-id="element-182">
              <Infinity className="w-4 h-4 mr-1.5 text-brand-teal" data-id="element-183" /> Acceso
              para siempre
            </span>
            <span className="flex items-center" data-id="element-184">
              <ShieldAlert className="w-4 h-4 mr-1.5 text-brand-teal" data-id="element-185" />{' '}
              Garantía 14 días
            </span>
          </div>
        </div>

        <div className="order-1 md:order-2 flex justify-center relative" data-id="element-186">
          <div className="relative w-full max-w-md" data-id="element-187">
            <img src="https://cdn.magicpatterns.com/uploads/h4nX1CK9HnX9YFutro1y63/mockup_nuevo.png" alt="Pack Completo Digital DOG-CALM" className="w-full h-auto rounded-[20px] shadow-2xl relative z-10" data-id="element-188" />
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-gold rounded-full opacity-20 blur-3xl" data-id="element-189"></div>
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-brand-teal rounded-full opacity-20 blur-3xl" data-id="element-190"></div>
          </div>
        </div>
      </div>
    </section>;
}